import type { ReactNode } from "react";

const BANK_ACCOUNT_LINE = /^(.*\S) \*(\d{4})$/;

/**
 * Splits `NAME *1234` so the name ellipsizes and the last four stay visible.
 * Any other string is returned unchanged.
 */
export function renderBankAccountLine(text: string): ReactNode {
  const match = text.match(BANK_ACCOUNT_LINE);
  if (!match) return text;
  return (
    <span style={{ display: "flex", minWidth: 0, maxWidth: "100%" }}>
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
        }}
      >
        {match[1]}
      </span>
      <span style={{ flex: "0 0 auto", paddingInlineStart: "0.35em" }}>
        *{match[2]}
      </span>
    </span>
  );
}
